import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isVisible: false,
    base64data: null,
    isLoading: false,
    isFetchSuccessful: false,
    invoiceNumber: null
  },
  getters: {
    isVisible: (state) => state.isVisible,
    base64data: (state) => state.base64data,
    isLoading: (state) => state.isLoading,
    isFetchSuccessful: (state) => state.isFetchSuccessful
  },
  mutations: {
    reset (state) {
      state.isVisible = false
      state.base64data = null
      state.isLoading = false
      state.invoiceNumber = null
      state.isFetchSuccessful = false
    },
    toggleModal (state) {
      state.isVisible = !state.isVisible
    },
    setBase64Data (state, payload) {
      state.base64data = payload
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setIsFetchSuccessful (state) {
      state.isFetchSuccessful = !state.isFetchSuccessful
    },
    setInvoiceNumber (state, number) {
      state.invoiceNumber = number
    }
  },
  actions: {
    async fetchInvoiceAsPDF ({ commit, state }, id) {
      commit('toggleLoading')
      const response = await new ApiService(`e_x_s_b_invoices/${id}/pdf`).get()
      let data = await response.arrayBuffer()
      let myBlob = new Blob([data], { type: 'application/pdf' })
      let reader = new FileReader()
      reader.readAsDataURL(myBlob)
      reader.onloadend = () => {
        commit('setBase64Data', reader.result)
      }
      commit('setIsFetchSuccessful')
      commit('toggleLoading')
    },
    downloadPdf ({ commit, state }) {
      const linkSource = state.base64data
      const downloadLink = document.createElement('a')
      const fileName = `FV-${state.invoiceNumber}.pdf`
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    }
  }
}
